<script>
import { postJson } from '../services';
import CircularProgress from './CircularProgress.svelte';
import * as config from '../config.json';

let submitted = false;

let first = '';
let last = '';
let email = '';
let phone = '';
let company = '';
let message = '';

let errors = {}

let loading = false;
let error;

async function send() {
  const state = {
    first: first.trim(),
    last: last.trim(),
    email: email.trim(),
    phone: phone.trim(),
    company: company.trim(),
    message: message.trim()
  }

  errors = {}
  error = undefined;
  let hasError = false;

  if (state.first.length === 0) {
    errors['first'] = 'Please provide your first name'
    hasError = true;
  }

  if (state.last.length === 0) {
    errors['last'] = 'Please provide your last name'
    hasError = true;
  }

  if ((state.email || '').indexOf('@') === -1) {
    errors['email'] = 'Please provide a valid email address'
    hasError = true;
  }

  if (state.message.length === 0) {
    errors['message'] = 'Please enter your message'
    hasError = true;
  }

  if (!hasError) {
    loading = true;
    
    try {
      await postJson('help', {...state, eventId: config.eventId});
      submitted = true;
    } catch (e) {
      error = e.message;
    } finally {
      loading = false;
    }
  }
}

</script>

<!-- <div class="section-header">HELP DESK</div> -->
    
<div class="container">
  <div class="title mb-2">Help desk request</div>

  {#if !submitted} 
    <div class="sub-text mb-4">Please submit any questions or issues you encounter on the platform here.</div>
    <div class="rowtocol">
      <div class="col flex-1">
        <div class='label'>First Name*</div>
        <input type='text' name="first" bind:value={first} />
        {#if errors['first']}
          <div class='error'>{errors['first']}</div>
        {/if}
      </div>
      <div class="gutter" />
      <div class="col flex-1">
        <div class='label'>Last Name*</div>
        <input type='text' name="last" bind:value={last} />
        {#if errors['last']}
          <div class='error'>{errors['last']}</div>
        {/if}
      </div>
    </div>
    
    <div class="row">
      <div class="col flex-1">
        <div class='label'>Email*</div>
        <input type='email' name="email" bind:value={email} />
        {#if errors['email']}
          <div class='error'>{errors['email']}</div>
        {/if}
      </div>
    </div>

    <div class="rowtocol">
      <div class="col flex-1">
        <div class='label'>Phone Number</div>
        <input type='text' name="phone" bind:value={phone} />
      </div>
      <div class="gutter" />
      <div class="col flex-1">
        <div class='label'>Company</div>
        <input type='text' name="company" bind:value={company} />
      </div>
    </div>

    <div class="row">
      <div class="col flex-1">
        <div class='label'>Comments*</div>
        <textarea bind:value={message} />
        {#if errors['message']}
          <div class='error'>{errors['message']}</div>
        {/if}
      </div>
    </div>

    {#if error}
      <div class="error-box">
        {error}
      </div>
    {/if}

    <div class="row" style="justify-content: flex-end;margin-top: 16px">
      {#if loading}
        <CircularProgress color='var(--guardsmen-red)' />
      {:else}
        <button disabled={loading} class="btn live" type='button' on:click={send}> SUBMIT</button>
      {/if}
    </div>

  {:else}
    <h3>Submitted!</h3>

    <div>
      We will respond to your message as soon as possible.
    </div>
  {/if}
</div>

<style lang="scss">
@import '../util';

input, textarea {
  @apply text-black;
}

.title {
  font-size: 32px;
  font-weight: normal;
  // text-transform: uppercase;
}
.label {
  font-size: 16px;
  margin: 16px 0 10px 0;
}

textarea {
  width: 100%;
  height: 200px;
  padding: 6px;
}

.error {
  color: white;
  background-color: var(--guardsmen-red);
  align-self: flex-start;
  padding: 2px 4px;
  border-radius: 3px;
  margin-left: 2px;
  margin-top: 2px;
}

.container {
  background-color: var(--primary);
  color: var(--text-primary);
  padding: 36px;
  max-width: 800px;

  @include shadow;

  @include landscape {
    width: 100%;
  }
}

.sub-text {
  font-size: 16px;
  font-weight: normal;
}
</style>